import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type {
  Allergen,
  IAllergenService as IAllergenServiceInterface,
} from './allergen.service.interface';

@Injectable()
export class AllergenService implements IAllergenServiceInterface {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async findAll(): Promise<Allergen[]> {
    return this.http.get<Allergen[]>('allergens');
  }
}
